import { CoreMIReport } from "api/resources/models/AutoGenerated";
import { DataGridCell } from "devextreme/common/export/excel";
import { formatCurrency } from "utils/helpers";

export const valuesConverter = (data: CoreMIReport[]) => {
  return data.map((row) => {
    return {
      ...row,
      vehicleStillOnSite: row.vehicleStillOnSite ? 'TRUE' : 'FALSE',
      courtesyCarOut: row.courtesyCarOut ? 'TRUE' : 'FALSE',
    };
  });
};

export const customizeCell = ({
  gridCell,
  excelCell,
}: {
  gridCell?: DataGridCell;
  excelCell?: any;
}) => {
  if (gridCell) {
    if (gridCell.column?.format === '£#,##0.00' && gridCell.value) {
      excelCell.value = formatCurrency(gridCell.value);
    }
  }
};
